// Copyright (c) Ping. All rights reserved.

import type { Note, NotesSort } from './types';

const PREVIEW_MAX_CHARS = 120;

/**
 * Pure helper. Collapses whitespace runs to a single space and truncates
 * with an ellipsis. Note bodies are sensitive — never log the input or
 * output (Hard rule 3).
 */
export function buildPreview(body: string): string {
  const single = body.replace(/\s+/g, ' ').trim();
  if (single.length <= PREVIEW_MAX_CHARS) {
    return single;
  }
  return `${single.slice(0, PREVIEW_MAX_CHARS).trim()}…`;
}

/** Pure case-insensitive search across `title` only. Body is sensitive — never indexed in this slice. */
export function searchNotes(notes: readonly Note[], query: string): readonly Note[] {
  const trimmed = query.trim();
  if (trimmed.length === 0) {
    return notes;
  }
  const lower = trimmed.toLowerCase();
  return notes.filter((note) => note.title.toLowerCase().includes(lower));
}

/** Pure comparator-based sort. Returns a new array; never mutates input. */
export function sortNotes(notes: readonly Note[], sort: NotesSort): readonly Note[] {
  const copy = notes.slice();
  switch (sort) {
    case 'mostRecent':
      copy.sort((a, b) => b.updatedAt - a.updatedAt);
      return copy;
    case 'title':
      copy.sort((a, b) => a.title.localeCompare(b.title));
      return copy;
  }
}
